import styled, { css } from 'styled-components';
import { Button } from '@perch-labs/shrike';
import { Container } from 'styles';

export const Wrapper = styled.div<StyleProps>`
  background: white;
  height: ${props => (props.expanded ? 'initial' : props.previewHeight)};
  padding-bottom: ${props => (props.expanded ? '32px' : null)};
  overflow: hidden;
  position: relative;

  ${props =>
    css`
      @media (min-width: ${props.theme.media.breakpoints.small + 1}px) {
        height: initial;
        padding-bottom: 32px;

        ${Gradient}, ${ExpandButton} {
          display: none;
        }
      }
    `}
`;

export const Gradient = styled.div<StyleProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: ${props =>
    `linear-gradient(rgba(255,255,255,0) ${props.percent}, white)`};
`;

export const ExpandButton = styled(Button).attrs({
  backgroundless: true,
  color: 'secondary',
  margin: '4px 2px',
})`
  padding: 24px;
  width: calc(100% - 4px);
  text-align: center;
  background: white;
  border-radius: 0;
`;

export const ButtonContainer = styled(Container).attrs({})`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;
